// removed by extract-text-webpack-plugin
module.exports = {"borderGray":"#D3D6DC","placeholderGray":"#9297A3","valueBlack":"#222628","iconGreen":"#1ddd7c","iconGray":"#6D717A","disabledGray":"#f7f7f7","errorRed":"#DC001C","selectBlue":"#ebf5ff","container":"container-3-GEX","label":"label-Y5lvX","disabled":"disabled-SOWJf","bold":"bold-vIMON","required":"required-3YAAZ","inputContainer":"inputContainer-37Qrp","input":"input-2t6DG","short":"short-2eEoB","inputError":"inputError-2jP1m","errorMessage":"errorMessage-ucFof","slim":"slim-2C1LB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/_field.css
// module id = 536
// module chunks = 1